import { store } from '@betacrew/jars-flux'
export const componentKey = "GLOBAL/TOASTERS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        addNotifications: (state, action) => {
            state.notifications = [...state.notifications, action.payload];
        },
        removeNotification: (state, action) => {
            state.notifications = state.notifications.filter((n, idx) => idx != action.payload)
        }
    },
    initialReducerState: {
        notifications: []
    }
});

export const { addNotifications, removeNotification } = actions;